import React from 'react';
import { createPortal } from 'react-dom';
import { MapPin, Shield, CheckCircle2, X, Navigation } from 'lucide-react';

const LocationDisclosureModal = ({ isOpen, onAccept, onCancel, isDark = true }) => {
    if (!isOpen) return null;

    return createPortal(
        <div className="fixed inset-0 bg-black/80 z-[100000] flex items-center justify-center p-6 backdrop-blur-md animate-in fade-in duration-300">
            <div className={`w-full max-w-[360px] rounded-[32px] overflow-hidden shadow-2xl border ${isDark ? 'bg-neutral-900 border-white/10' : 'bg-white border-gray-100'} animate-in zoom-in-95 duration-300`}>
                
                {/* Header/Icon */}
                <div className="p-8 pb-4 text-center">
                    <div className="w-20 h-20 rounded-full bg-indigo-500/10 text-indigo-500 mx-auto mb-6 flex items-center justify-center shadow-inner">
                        <MapPin size={40} className="animate-pulse" />
                    </div>
                    
                    <h3 className={`text-2xl font-black tracking-tight ${isDark ? 'text-white' : 'text-gray-900'}`}>
                        Uso da Localização
                    </h3>
                    <p className={`text-sm mt-3 leading-relaxed ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                        Para que o recurso <span className="font-bold text-indigo-500">Jornada Pro</span> funcione corretamente, precisamos acessar sua localização.
                    </p>
                </div>

                {/* Benefits/Disclosure */}
                <div className="px-8 space-y-4 mb-8">
                    <div className={`p-4 rounded-2xl flex items-start gap-3 ${isDark ? 'bg-white/5' : 'bg-indigo-50/50'}`}>
                        <Navigation size={20} className="text-indigo-500 mt-1 shrink-0" />
                        <div>
                            <p className={`text-xs font-bold uppercase tracking-wider ${isDark ? 'text-gray-300' : 'text-indigo-900'}`}>Rastreamento em 2º Plano</p>
                            <p className={`text-[11px] mt-1 leading-normal ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                                O app coleta dados de localização para gravar suas rotas, calcular KM e custos, **mesmo quando o app está fechado ou não está em uso.** Na próxima tela do sistema, escolha **"Permitir o tempo todo"** — sem isso o GPS para ao minimizar.
                            </p>
                        </div>
                    </div>

                    <div className={`p-4 rounded-2xl flex items-start gap-3 ${isDark ? 'bg-white/5' : 'bg-emerald-50/50'}`}>
                        <Shield size={20} className="text-emerald-500 mt-1 shrink-0" />
                        <div>
                            <p className={`text-xs font-bold uppercase tracking-wider ${isDark ? 'text-gray-300' : 'text-emerald-900'}`}>Privacidade e Transparência</p>
                            <p className={`text-[11px] mt-1 leading-normal ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                                Esses dados são usados exclusivamente para o seu histórico pessoal e não são compartilhados com terceiros para fins publicitários.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Actions */}
                <div className="px-8 pb-8 space-y-3">
                    <button
                        onClick={onAccept}
                        className="w-full py-4 bg-indigo-600 hover:bg-indigo-700 text-white font-black rounded-2xl shadow-xl shadow-indigo-500/20 transition-all active:scale-[0.98] flex items-center justify-center gap-2"
                    >
                        <CheckCircle2 size={20} />
                        EU CONCORDO
                    </button>
                    <button
                        onClick={onCancel}
                        className={`w-full py-3 text-sm font-bold transition-colors ${isDark ? 'text-gray-500 hover:text-gray-300' : 'text-gray-400 hover:text-gray-600'}`}
                    >
                        Agora não
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default LocationDisclosureModal;
